module.exports = __webpack_public_path__ + "static/terms-8c7c1e54ca6bd7601d51707b7b772c1a.pdf";